// extracted by mini-css-extract-plugin
module.exports = {"Interests":"Interests_Interests__1Ta7t"};